export const pendoConstants = {
	INIT: "PENDO_INITIALIZE",
};
